import { render, staticRenderFns } from "./OtherUsersDetails.vue?vue&type=template&id=34990b71"
import script from "./OtherUsersDetails.vue?vue&type=script&lang=js"
export * from "./OtherUsersDetails.vue?vue&type=script&lang=js"
import style0 from "./OtherUsersDetails.vue?vue&type=style&index=0&id=34990b71&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports